<template>
  <app-layout>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/poker.svg" class="h-8 w-8"/>
        <span class="ml-2"> Planning Poker Dashboard</span>
      </h2>
    </template>
    <a-spin style="z-index: 99999;" :spinning="submitting">

      <!-- Delete Token Confirmation Modal -->
      <jet-confirmation-modal :show="deletedModal" @close="deletedModal = false">
        <template #title>
          Delete Poker Room
        </template>

        <template #content>
          Are you sure you would like to delete this room?
        </template>

        <template #footer>
          <jet-secondary-button @click="deletedModal = false">
            Cancel
          </jet-secondary-button>

          <jet-danger-button class="ml-2" @click="confirmDelete(selectedDeletedRoomId)"
                             :class="{ 'opacity-25': submitting }" :disabled="submitting">
            Delete
          </jet-danger-button>
        </template>
      </jet-confirmation-modal>

      <jet-dialog-modal maxWidth="2xl" :show="showEditModal === true" @close="showEditModal = false">


        <template #content>

          <edit-room-form @updated="getRooms" :room-name="this.selectedConfigRoom.room_name"
                          :id="this.selectedConfigRoom.room_id"></edit-room-form>
        </template>

        <template #footer>
          <div class="text-md text-blue-500 font-bold inline-block ml-1">
            agilesuite.io
          </div>
        </template>
      </jet-dialog-modal>


      <jet-dialog-modal maxWidth="2xl" :show="createPokerModal === true" @close="createPokerModal = false">


        <template #content>

          <create-room-form :is-team="true" :click-text="'Create Your Room'" @created="roomCreated"></create-room-form>
        </template>

        <template #footer>
          <div class="text-md text-blue-500 font-bold inline-block ml-1">
            agilesuite.io
          </div>
        </template>
      </jet-dialog-modal>

      <div class="h-screen flex overflow-hidden">


        <div class="flex flex-col w-0 flex-1 overflow-hidden">

          <main class="flex-1 relative overflow-y-auto focus:outline-none">
            <div class="">

              <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <bread-nav :pages="pages"></bread-nav>
                <!-- Replace with your content -->
                <div class="py-4">


                  <!-- Replace with your content -->


                  <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-2"
                       role="alert">
                    <p class="text-yellow-700 font-bold">Tips:</p>
                    <p class="text-gray-400 font-bold text-lg">Just send your room link to your team members then you
                      should be able to approve them.</p>
                  </div>

                  <div v-if="!this.$page.props.user.current_team" class="mt-2">
                    <div role="alert">
                      <div class="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                        You don't have a team:
                      </div>
                      <div class="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                        <p>Please create a team first via top team dropdown.</p>
                      </div>
                    </div>
                  </div>


                  <div>


                    <ul role="list" class="mb-4  grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">

                      <button @click="this.createPokerModal = true;" type="button"  :class="teamRooms.length> 0 ? '' : 'py-16'"
                              class="mb-4 col-span-1 px-8 text-lg text-gray-400 rounded-lg shadow divide-y divide-gray-200  border-2 border-gray-300 border-dashed hover:text-gray-500  hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
   <span class="py-2 block font-bold font-medium">
  + Create a new room for Team {{ this.$page.props.user.current_team.name }}
    </span>
                      </button>

                      <li v-if="teamRooms.length> 0" v-for="room in teamRooms" :key="room.id"
                          class="mb-4 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">

                        <PokerRoomCard :model-value="room" @deleting="deleteRoom"
                                       @config="openConfigDialog"></PokerRoomCard>
                      </li>
                    </ul>


                  </div>

                  <!-- /End replace -->


                </div>
                <!-- /End replace -->
              </div>
            </div>
          </main>
        </div>
      </div>


    </a-spin>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRoomForm from "@/Pages/PlanningPoker/CreateRoomForm";
import PokerRoomCard from "@/Pages/PlanningPoker/PokerRoomCard";
import EditRoomForm from "@/Pages/PlanningPoker/EditRoomForm";
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import BreadNav from "@/Components/BreadNav/BreadNav";

export default {
  props: ['teamId'],
  data() {
    return {
      createPokerModal: false,
      showSideBar: true,
      currentIndex: 1,
      myRooms: [],
      teamRooms: [],
      recentRooms: [],
      showEditModal: false,
      selectedDeletedRoomId: null,
      deletedModal: false,
      selectedConfigRoom: {
        roomId: null,
        roomName: null
      },
      submitting: false,
      pages: []
    };
  },
  mounted() {
    this.pages = [
      {name: 'Planning Poker', href: '#', current: false},
      {name: 'Team ' + this.$page.props.user.current_team.name + ' Rooms', href: '#', current: true},
    ]
  },
  created() {
    this.getRooms();
  },
  setup() {

    return {};
  },

  methods: {
    openConfigDialog(room) {
      this.selectedConfigRoom = room;
      this.showEditModal = true;
    },
    roomCreated() {
      this.createPokerModal = false;
      this.getRooms();
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#room" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    goToRoom(roomKey) {
      this.$inertia.visit(route("planning-rooms.accessRoom", {id: roomKey}), {
        preserveState: false
      })
    },
    confirmDelete(roomId) {
      let app = this;
      app.submitting = true;
      axios
          .delete(route("planning-rooms.delete", {id: roomId}))
          .then((response) => {
            app.submitting = false;
            if (response.data.success) {
              message.success("Successfully deleted.");
              app.getRooms();
            } else {
              message.error(response.data.message);
            }

          })
          .catch((error) => {
            app.submitting = false;
            message.error("Oops, unable to delete.");
            console.log(error);
          });
    },
    deleteRoom(roomId) {

      this.selectedDeletedRoomId = roomId;
      this.deletedModal = true;
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/rooms/' + id : 'https://agilesuite.io/rooms/' + id;
    },
    getRooms() {
      let app = this;
      app.submitting = true;
      axios
          .get(route("planning-rooms.getTeamRooms", {id: this.teamId}))
          .then((response) => {
            app.submitting = false;
            app.teamRooms = response.data.data;
            app.deletedModal = false;
          })
          .catch((error) => {
            app.submitting = true;
            console.log(error);
          });
    },
  },
  components: {
    BreadNav,
    JetConfirmationModal,
    EditRoomForm,
    PokerRoomCard,
    CreateRoomForm,
    JetDialogModal,
    JetDangerButton,
    JetSecondaryButton,
    Button,
    AppLayout,
  },
};
</script>
